const passedThreshold = (threshold) => document.documentElement.scrollTop > threshold;

const scrollFunction = (headerEls) => {
  const scrollThreshold = 5;
  headerEls.forEach((el) => {
    el.classList.toggle('header--scrolled', passedThreshold(scrollThreshold));
  });
};

const headerController = () => {
  const headerElements = document.querySelectorAll('#header, #mobile-header');
  window.addEventListener('scroll', () => scrollFunction(headerElements));
};

headerController();

// dynamically set margin top on hero sections for full bleed
const heroSection = document.querySelector('.hero-section');
const header = document.querySelector('.header-section');

function setHeroSectionMargin() {
  const { height } = header.getBoundingClientRect();
  heroSection.style.marginTop = `${height * -1}px`;
}

if (heroSection && header) {
  setTimeout(setHeroSectionMargin, 100);
  let timeout;
  window.addEventListener('resize', () => {
    clearTimeout(timeout);
    timeout = setTimeout(setHeroSectionMargin, 100);
  });
}
